<template>
  <HomeLayout class="container mx-auto">
    <KioskBanner class="py-10 sm:py-20" />
    <!--end::logo-->

    <div>
      <router-link to="/game/kiosk">
        <div class="mx-10 bg-white shadow-lg home-menu" data-type="button">
          <div class="flex">
            <div class="flex-1 py-3 text-center sm:py-6 sm:py-10 sm:text-left sm:pl-6">
              <h3 class="text-3xl font-bold tracking-tight sm:text-4xl">연습하기</h3>
              <p class="mt-2 font-light leading-snug text-gray-700 sm:mt-5">
                키오스크 연습을 해봅시다. <br />
                <strong class="font-bold text-black">초급,중급,고급</strong> 단계를 통해 <br />
                나도 이제 키오스크 마스터!
              </p>
            </div>
            <div
              class="hidden bg-right bg-cover sm:block sm:w-2/5"
              :style="{ backgroundImage: 'url(' + require('@assets/images/home-menu-2.png') + ')' }"
            ></div>
          </div>
        </div>
      </router-link>
    </div>
    <!--end::menu-1-->

    <div class="mt-5">
      <router-link to="/faq">
        <div class="mx-10 bg-white shadow-lg home-menu" data-type="button">
          <div class="flex">
            <div class="flex-1 py-3 text-center sm:py-6 sm:py-10 sm:text-left sm:pl-6">
              <h3 class="text-3xl font-bold tracking-tight sm:text-4xl">단어설명</h3>
              <p class="mt-2 font-light leading-snug text-gray-700 sm:mt-5">
                연습을 하다가 <br />
                <strong class="font-bold text-black">잘 모르는 단어가 있나요?</strong> <br />
                친절히 설명해드릴게요!
              </p>
            </div>
            <div
              class="hidden bg-right bg-cover sm:block sm:w-2/5"
              :style="{ backgroundImage: 'url(' + require('@assets/images/home-menu-3.png') + ')' }"
            ></div>
          </div>
        </div>
      </router-link>
    </div>
    <!--end::menu-2-->
  </HomeLayout>
</template>

<script>
import appConfig from '@src/app.config'
import HomeLayout from '@layouts/home-layout.vue'
import KioskBanner from '@components/layout/kiosk-banner.vue'

export default {
  page: {
    title: appConfig.title,
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { KioskBanner, HomeLayout },
  methods: {
    exit() {
      // after check the device for mobile
      alert('앱에서만 지원하는 기능 입니다.')
    },
  },
}
</script>

<style scoped>
.home-menu {
  border-radius: 20px;
  border: 1px solid #dbd5c3;
}
</style>
